<template>
    <div class="sc-eHgmQL cHdXio" v-if="dataVal.flag">
        <!-- 遮罩层 -->
        <div class="sc-jWBwVP jRyTMm" style="opacity: 1;"></div>
        <!-- 登录 -->
        <div v-show="type == 'login'" class="sc-cvbbAY cNJVTK">
            <div class="sc-hSdWYo fBwJYU sc-gqPbQI fFchEg" style="opacity: 1; transform: none;">
                <div class="sc-brqgnP dpDcJQ"></div>
                <img src="@/assets/images/logo.png">

                <form class="sc-iuJeZd ijJkeu">
                    <div class="sc-hZSUBg dYHIHv">
                        <section class="sc-gipzik hALLUv" style="width: 100%;">
                            <label>
                                <div class="label-container">
                                    <span>Email</span>
                                </div>
                                <div class="sc-iRbamj iSsjwN sc-bsbRJL dSuRZi" label="Email">
                                    <input autocomplete="username" placeholder="name@company.com" type="text"
                                        v-model="form.email" class="sc-Rmtcm cuxnDU" value="">
                                </div>
                            </label>
                        </section>

                        <section class="sc-gipzik hALLUv" style="width: 100%;">
                            <label>
                                <div class="label-container paddTop">
                                    <span>Password</span>
                                    <span class="label-addon">
                                        <a @click="type = 'reset'" tabindex="-1" class="sc-esOvli cGMEBJ">
                                            Forgot password?
                                        </a>
                                    </span>
                                </div>
                                <div class="sc-iRbamj iSsjwN sc-bsbRJL dSuRZi" label="Password">
                                    <input autocomplete="current-password"
                                        placeholder="Password (at least 6 characters)" type="password"
                                        v-model="form.password" class="sc-Rmtcm cuxnDU" value="">
                                </div>
                            </label>
                        </section>

                        <!-- <div @click="checked = !checked" class="sc-cMhqgX ijZhMg">
                            <div class="sc-eTuwsz fPUQUQ">
                                <a :class="['sc-gwVKww', checked ? 'laTaXa' : 'sc-hXRMBi fxcinP']">
                                    <i class="sc-epnACN eGBihe icon-confirm"></i>
                                </a>
                                <div class="sc-iQNlJl jACZzU">Remember me</div>
                            </div>
                        </div> -->
                        <button @click="handleLogin" label="Log In" type="submit" class="sc-gzVnrw JSdDc">
                            <span>Log In</span>
                        </button>
                        <p class="agreement">
                            By continuing you agree to the
                            <a @click="handleTo('/agreement', { type: 'xieyi' })">terms of service</a>
                            <span> and </span>
                            <a @click="handleTo('/agreement', { type: 'yinsi' })">privacy&nbsp;policy</a>
                        </p>
                    </div>
                </form>

                <div class="sc-hMFtBS jLMGdg">
                    <div class="sc-cmthru hOrakO">Don't have an account?</div>
                    <a class="sc-bZQynM hAOjtp" href="#/signup">
                        <button label="Sign Up" type="button" class="sc-gzVnrw gLKNrW" @click="handleTo('/signup')">
                            <span>Sign Up</span>
                        </button>
                    </a>
                </div>

                <a href="https://www.koiodeal.com" class="sc-cLQEGU hiRtQe">Go to homepage</a>
            </div>
        </div>
        <!-- 忘记密码 -->
        <div v-show="type == 'reset'" class="sc-cvbbAY cNJVTK">
            <div class="sc-hSdWYo fBwJYU" style="opacity: 1; transform: none;">
                <div class="sc-brqgnP dpDcJQ">Reset Password</div>

                <div class="sc-bXGyLb fcoodW fcoodW2">Enter your email</div>
                <div class="sc-exAgwC bzJfwl">
                    <section class="sc-gipzik hALLUv">
                        <label>
                            <div class="sc-iRbamj hcvzFB sc-cQFLBn dLzbhb">
                                <input placeholder="Email" type="text" v-model="formReset.email" class="sc-Rmtcm cuxnDU"
                                    value="">
                            </div>
                        </label>
                    </section>
                </div>
                <div class="sc-bXGyLb fcoodW fcoodW2">Obtain email verification code</div>
                <div class="sc-exAgwC bzJfwl">
                    <section class="sc-gipzik hALLUv">
                        <label>
                            <div class="hALLUvbox">
                                <div class="sc-iRbamj hcvzFB sc-cQFLBn dLzbhb">
                                    <input placeholder="Verification Code" type="text" v-model="formReset.yzm"
                                        class="sc-Rmtcm cuxnDU" value="">
                                </div>
                                <button label="Get Code" type="button"
                                    :class="['sc-gzVnrw JSdDc', emailError ? 'JSdDcdisabled' : '']"
                                    @click="handleGetCode" :disabled="codeDisabled">{{ codeDisabled ? codeTime + 's' :
                                        'Get Code' }}</button>
                            </div>
                        </label>
                    </section>
                </div>
                <div class="sc-bXGyLb fcoodW fcoodW2">New Password</div>
                <div class="sc-exAgwC bzJfwl">
                    <section class="sc-gipzik hALLUv">
                        <label>
                            <div class="sc-iRbamj hcvzFB sc-cQFLBn dLzbhb">
                                <input placeholder="New Password" type="text" v-model="formReset.password"
                                    class="sc-Rmtcm cuxnDU" value="">
                            </div>
                        </label>
                    </section>
                </div>

                <!-- <div class="sc-bXGyLb fcoodW">Go back to login?</div> -->

                <a class="sc-bZQynM hAOjtp">
                    <button label=" Reset Password " type="button" class="sc-gzVnrw gLKNrW" @click="handleRegister">
                        <span> Reset Password </span>
                    </button>
                </a>

                <a class="sc-eLExRp gBJyxw" @click="type = 'login'">Back</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            checked: false,
            type: 'login',
            token: true,

            form: {
                type: 2,
                email: '',
                password: ''
            },

            emailError: true,
            codeTimer: null,
            codeTime: 60,
            codeDisabled: false,
            formReset: {
                type: 2,
                email: '',
                yzm: '',
                password: ''
            }
        }
    },
    props: {
        dataVal: {
            type: Object,
            default: () => ({
                flag: false
            })
        }
    },
    mounted() {

    },
    methods: {
        async handleLogin() {
            let res = await this.$api.userLogin(this.form)
            if (res.code == 1) {
                window.localStorage.setItem('token', res.data.token)
                this.$emit('loginCall', { flag: false, type: 'login' })
            }
            // window.localStorage.setItem('token', '123456')
            // this.$emit('loginCall', { flag: false })
        },
        async handleGetCode() {
            if (!this.formReset.email) {
                this.$message.error('Please enter your email')
                return
            }
            if (this.emailError) {
                this.$message.error('Please enter a valid email')
                return
            }
            if (this.codeDisabled) return
            this.codeDisabled = true
            this.codeTime = 60
            if (this.codeTimer) {
                clearInterval(this.codeTimer)
            }
            let res = await this.$api.userSendyzm({
                email: this.formReset.email
            })
            if (res.code == 1) {
                this.codeTimer = setInterval(() => {
                    this.codeTime--
                    if (this.codeTime <= 0) {
                        this.codeDisabled = false
                        clearInterval(this.codeTimer)
                    }
                }, 1000)
            }
        },
        async handleRegister() {
            let res = await this.$api.userResetpwd(this.formReset)
            if (res.code == 1) {
                this.$message.success('Password reset successfully')
                this.form.email = this.formReset.email
                this.form.password = this.formReset.password
                this.type = 'login'
            }
        },
        handleTo(url, query) {
            let obj = {
                path: url,
            }
            if (query) {
                obj.query = query
            }
            this.$router.push(obj);
        }
    },
    watch: {
        dataVal: {
            handler(newVal) {
                if (newVal.flag) {
                    this.form = {
                        type: 2,
                        email: '',
                        password: ''
                    }
                }
            },
            deep: true
        },
        formReset: {
            handler(newVal) {
                // 识别邮箱格式
                if (newVal.email) {
                    if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(newVal.email)) {
                        this.emailError = true
                        return
                    } else {
                        this.emailError = false
                    }
                }

            },
            deep: true,
            immediate: true
        }
    }
}
</script>
<style lang="scss" scoped>
.cHdXio {
    height: 100vh;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}

.jRyTMm {
    background-color: rgba(0, 0, 0, 0.8);
    height: 101vh;
    -webkit-box-pack: center;
    justify-content: center;
    left: 0px;
    position: fixed;
    top: -1px;
    width: 100%;
    z-index: 1;
}

.cNJVTK {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    height: 100%;
    z-index: 4;
    padding: 0px !important;
}

.fBwJYU {
    -webkit-box-align: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    box-shadow: rgba(64, 64, 64, 0.52) 0px 0px 30px 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 10px 0px;
    max-height: 100vh;
    max-width: 100%;
    min-width: 50vw;
    overflow: auto;
    padding: 30px 40px;
    position: relative;
    z-index: 2;
}

.dpDcJQ {
    max-width: 500px;
    font-size: 32px;
    font-weight: 700;
    width: 100%;
    margin-bottom: 20px;
}

.fFchEg img {
    margin-bottom: 20px;
    max-width: 250px;
}

.ijJkeu {
    max-width: 500px;
    width: 100%;
}

.dYHIHv {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.hALLUv {
    width: 100%;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;

    label {
        font-size: 14px;
        font-weight: 500;
    }

    .label-container {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
    }
}

.hALLUvbox {
    width: 100%;
    display: flex;
}

.iSsjwN {
    background-color: inherit;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    margin-bottom: 15px;
    margin-top: 7px;
    position: relative;
    width: 100%;
}

.cuxnDU {
    background: transparent;
    border: none;
    border-radius: 10px;
    box-sizing: border-box;
    font-family: effra, sans-serif;
    font-size: 14px;
    outline: none;
    padding: 7px 12px;
    width: 100%;
    z-index: 2;
}

.dSuRZi input {
    padding: 10px;
}

.ijZhMg {
    margin-bottom: 20px;
    width: 100%;
}

.fPUQUQ {
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    user-select: none;
    width: fit-content;
}

.fxcinP {
    border-radius: 100%;
    height: 14px;
    text-align: center;
    width: 14px;
    background: transparent;
    border: 1px solid rgb(160, 160, 160);
    color: rgb(160, 160, 160);

    i {
        visibility: hidden;
    }
}

.eGBihe {
    display: block;
    font-size: 11px;
    margin-top: 1px;
    padding: 0px;
}

.jACZzU {
    font-size: 12px;
    margin-left: 7px;
    color: rgb(157, 157, 157);
}

.fFchEg button {
    min-width: 100px;
    padding: 10px 30px;

    &:first-of-type {
        width: 100%;
    }
}

.dYHIHv button {
    margin-bottom: 20px;
}

.JSdDc {
    -webkit-box-align: center;
    align-items: center;
    background: black;
    border: none;
    border-radius: 30px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-family: effra, sans-serif;
    font-size: 14px;
    -webkit-box-pack: center;
    justify-content: center;
    align-items: center;
    outline: none;
    padding: 7px 20px;
    white-space: nowrap;
    width: 100px;
    height: 31px;
    margin-left: 10px;
}

.JSdDcdisabled {
    background: #ccc;
    cursor: not-allowed;
}

.dYHIHv .agreement {
    color: rgb(157, 157, 157);
    font-size: 12px;
    line-height: 1.4;
    margin: 0px;
    padding-left: 3px;
    text-align: center;
    width: 100%;

    span {
        padding: 0px 2px;
    }
}

.jLMGdg {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    max-width: 500px;
    padding-bottom: 40px;
}

.hOrakO {
    color: rgb(51, 51, 51);
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 20px;
    margin-top: 40px;
    max-width: 500px;
    width: 100%;
}

.hAOjtp {
    display: inline-block;
    text-decoration: none;
}

.gLKNrW {
    -webkit-box-align: center;
    align-items: center;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(204, 204, 204);
    border-radius: 30px;
    color: rgb(68, 68, 68);
    cursor: pointer;
    display: flex;
    font-family: effra, sans-serif;
    font-size: 14px;
    -webkit-box-pack: center;
    justify-content: center;
    outline: none;
    padding: 7px 20px;
    white-space: nowrap;
}

.hiRtQe {
    color: rgb(101, 101, 101);
    cursor: pointer;
    font-size: 12px;
    text-decoration: underline;
}

.laTaXa {
    background: rgb(0, 0, 0);
    border: 1px solid rgb(0, 0, 0);
    border-radius: 100%;
    color: white;
    height: 14px;
    text-align: center;
    width: 14px;
}

.cNJVTK {
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    height: 100%;
    z-index: 4;
    padding: 0px !important;
}

.fcoodW {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 10px;
}

.fcoodW2 {
    width: 100%;
    max-width: 500px;
}

.bzJfwl {
    -webkit-box-align: center;
    align-items: center;
    // border-bottom: 1px solid rgb(238, 238, 238);
    display: flex;
    flex-direction: column;
    // padding-bottom: 40px;
    max-width: 500px;
    width: 100%;
}

.dLzbhb {
    margin-bottom: 18px;
}

.hcvzFB {
    background-color: inherit;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    margin-bottom: 15px;
    margin-top: 0px;
    position: relative;
    width: 100%;
}

.JSdDc:hover {
    transform: scale(1.04) translateZ(0px);
}

.gBJyxw {
    color: rgb(101, 101, 101);
    cursor: pointer;
    font-size: 12px;
    text-decoration: underline;
    margin-top: 30px;
}
</style>